interface HeaderContainerProps {
    children: React.ReactElement | React.ReactElement[]
}

export const HeaderContainer = ({children}: HeaderContainerProps) =>
    <div className='w-full h-[60px] bg-slate-800 text-slate-300 flex items-center px-4 justify-around flex-grow-0 flex-shrink-0'>
        {children}
    </div>